import React from 'react';
import { Field } from 'react-form';

export function AfficherFeedback(input, valide) {
    input.current.setAttribute('class', valide ? 'form-control is-valid' : 'form-control is-invalid');
}

export const Texte = ({
    onChange, onBlur, defaultvalue, placeholder, readOnly, type, refRef, field, ...rest
}) => (
    <Field field={field}>
        {(fieldApi) => {
            const { value, setValue, setTouched } = fieldApi;

            return (
                <input
                    {...rest}
                    value={value || defaultvalue || ''}
                    onChange={(e) => {
                        setValue(e.target.value);
                        if (onChange) {
                            onChange(e.target.value, e);
                        }
                    }}
                    onBlur={(e) => {
                        setTouched();
                        if (onBlur) {
                            onBlur(e);
                        }
                    }}
                    className="form-control"
                    autoComplete="off"
                    type={type}
                    placeholder={placeholder}
                    readOnly={readOnly}
                    ref={refRef}
                />
            );
        }}
    </Field>
);

export const ZoneTexte = ({
    onChange,
    onBlur,
    defaultvalue,
    placeholder,
    readOnly,
    rows,
    type,
    refRef,
    field,
    ...rest
}) => (
    <Field field={field}>
        {(fieldApi) => {
            const { value, setValue, setTouched } = fieldApi;

            return (
                <textarea
                    {...rest}
                    value={value || defaultvalue || ''}
                    onChange={(e) => {
                        setValue(e.target.value);
                        if (onChange) {
                            onChange(e.target.value, e);
                        }
                    }}
                    onBlur={(e) => {
                        setTouched();
                        if (onBlur) {
                            onBlur(e);
                        }
                    }}
                    className="form-control"
                    autoComplete="off"
                    type={type}
                    placeholder={placeholder}
                    readOnly={readOnly}
                    rows={rows}
                    ref={refRef}
                />
            );
        }}
    </Field>
);

export const Liste = ({
    onChange,
    onBlur,
    id,
    defaultvalue,
    placeholder,
    readOnly,
    required,
    refRef,
    field,
    options,
    ...rest
}) => (
    <Field field={field}>
        {(fieldApi) => {
            const { value, setValue, setTouched } = fieldApi;

            const resolvedOptions =
                options.find(d => d.value === '') || placeholder === false
                    ? options
                    : [
                        {
                            label: placeholder || 'Select One...',
                            value: '',
                            disabled: true,
                        },
                        ...options,
                    ];

            const nullIndex = resolvedOptions.findIndex(d => d.value === '');
            const selectedIndex = resolvedOptions.findIndex(d => d.value === value);

            return (
                <select
                    {...rest}
                    id={id}
                    value={selectedIndex > -1 ? selectedIndex : nullIndex}
                    onChange={(e) => {
                        const val = resolvedOptions[e.target.value].value;
                        setValue(val);
                        if (onChange) {
                            onChange(val, e);
                        }
                    }}
                    onBlur={(e) => {
                        setTouched();
                        if (onBlur) {
                            onBlur(e);
                        }
                    }}
                    className="form-control"
                    autoComplete="off"
                    placeholder={placeholder}
                    readOnly={readOnly}
                    required={required}
                    ref={refRef}
                >
                    {resolvedOptions.map((option, i) => (
                        <option key={option.value} value={i} disabled={option.disabled}>
                            {option.label}
                        </option>
                    ))}
                </select>
            );
        }}
    </Field>
);

export const Case = ({
    onChange, onBlur, refRef, field, ...rest
}) => (
    <Field field={field}>
        {(fieldApi) => {
            const { value, setValue, setTouched } = fieldApi;

            return (
                <input
                    {...rest}
                    checked={!!value}
                    onChange={(e) => {
                        setValue(e.target.checked);
                        if (onChange) {
                            onChange(e.target.checked, e);
                        }
                    }}
                    onBlur={(e) => {
                        setTouched();
                        if (onBlur) {
                            onBlur(e);
                        }
                    }}
                    className="form-check-input"
                    type="checkbox"
                />
            );
        }}
    </Field>
);



// WEBPACK FOOTER //
// ./src/components/ChampFormulaire.js